var map = {
	"./auto_logo.svg": "2e41",
	"./edit.svg": "aa46",
	"./eye.svg": "4df5",
	"./ic_menu.svg": "ebfa",
	"./login-loading.svg": "0209",
	"./menu-user.svg": "61d0",
	"./monthly.svg": "edd3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";